import React, { useState } from 'react';
import PageShell from '../../components/PageShell';
import { Eyebrow, SectionHeading, InfoCard } from '../../components/common/Primitives';
import { AtSign } from 'lucide-react';
import { BRAND } from '../../lib/mock';
import { useToast } from '../../hooks/use-toast';

export default function MediaContact() {
  const { toast } = useToast();
  const [values, setValues] = useState({});
  const submit = (e) => { e.preventDefault(); toast({ title: 'Enquiry recorded (mock).', description: 'When backend + email are enabled, it will be sent to '+BRAND.contactEmail+'.' }); };
  return (
    <PageShell>
      <section className="px-6 pt-12 pb-8">
        <div className="mx-auto max-w-[1240px]">
          <Eyebrow color="purple">MEDIA RESOURCE</Eyebrow>
          <h1 className="mt-2 text-[42px] md:text-[52px] font-extrabold leading-[1.06] tracking-tight text-navy">Media contact and enquiries</h1>
          <p className="mt-5 max-w-2xl text-[15.5px] leading-relaxed text-ink-500">Contact the Gyan Dhara project team for interviews, project information, approved visual material and publication support.</p>
        </div>
      </section>

      <section className="px-6 py-8">
        <div className="mx-auto max-w-[1240px]">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-[1fr_1.4fr]">
            <div className="rounded-2xl bg-navy p-6 text-white shadow-card">
              <div className="flex items-center gap-3"><span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan"><AtSign className="h-5 w-5" /></span><div><div className="text-[16px] font-bold">Dr. Keyur Sorathia</div></div></div>
              <p className="mt-3 text-[13px] text-white/75">Principal Investigator, Gyan Dhara<br/>Associate Professor, Department of Design<br/>Indian Institute of Technology Guwahati</p>
              <a href={`mailto:${BRAND.contactEmail}`} className="mt-4 block text-[13px] font-bold text-cyan">{BRAND.contactEmail}</a>
              <a href={`mailto:${BRAND.contactEmail}`} className="mt-4 inline-block rounded-lg bg-white px-4 py-2 text-[13px] font-semibold text-navy">Email Media Contact</a>
            </div>
            <div className="rounded-2xl border border-canvas-200 bg-white p-6 shadow-soft">
              <div className="text-[13.5px] font-bold text-navy">How the media team can help</div>
              <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {[
                  { icon: 'Mic',           title: 'Interview request',      desc: 'Schedule an interaction with the Principal Investigator.' },
                  { icon: 'FileText',      title: 'Project information',    desc: 'Request verified background and deployment context.' },
                  { icon: 'ImageIcon',     title: 'Approved media assets',  desc: 'Request logos, photographs, screenshots and video.' },
                  { icon: 'CalendarClock', title: 'Partnership or event',   desc: 'Discuss demonstrations, events and announcements.' },
                ].map((t,i)=>{
                  const Icon = require('lucide-react')[t.icon] || require('lucide-react').Sparkles;
                  const color = ['purple','royal','cyan','mint'][i];
                  return (
                    <div key={i} className="rounded-xl border border-canvas-200 bg-white p-4 shadow-soft transition-transform hover:-translate-y-0.5">
                      <span className={`inline-flex h-9 w-9 items-center justify-center rounded-lg bg-${color}-50 text-${color}`}><Icon className="h-4 w-4" /></span>
                      <div className="mt-3 text-[13.5px] font-bold text-navy">{t.title}</div>
                      <div className="mt-1 text-[12px] text-ink-500 leading-snug">{t.desc}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-6 py-16 pb-24">
        <div className="mx-auto max-w-[1240px]">
          <SectionHeading eyebrow="CONTACT FORM" title="Send a media enquiry" desc="Provide enough context for the team to prepare the appropriate information or material." />
          <form onSubmit={submit} className="mt-8 rounded-2xl border border-canvas-200 bg-white p-6 md:p-8 shadow-soft grid grid-cols-1 gap-5 md:grid-cols-2">
            {[['Full name','name'],['Organisation or publication','org'],['Email','email','email'],['Phone','phone'],['Enquiry type','type'],['Preferred response date','date','date']].map(([label,key,type])=>(
              <label key={key} className="block"><span className="text-[12.5px] text-ink-500">{label}</span><input type={type||'text'} onChange={e=>setValues(v=>({...v,[key]:e.target.value}))} className="mt-1 w-full rounded-lg border border-canvas-200 px-3 py-2.5 text-[13.5px] focus:border-purple" required={key==='name'||key==='email'} /></label>
            ))}
            <label className="block md:col-span-2"><span className="text-[12.5px] text-ink-500">Message</span><textarea rows={5} onChange={e=>setValues(v=>({...v,message:e.target.value}))} className="mt-1 w-full rounded-lg border border-canvas-200 px-3 py-2.5 text-[13.5px] focus:border-purple" placeholder="Describe the interview, information or visual assets required." /></label>
            <div className="md:col-span-2 flex items-center gap-4"><button className="rounded-lg bg-brand-gradient px-5 py-2.5 text-[13.5px] font-semibold text-white shadow-soft">Submit Media Enquiry</button><span className="text-[12.5px] text-ink-500">The project team will normally acknowledge the enquiry within 48 hours.</span></div>
          </form>
        </div>
      </section>
    </PageShell>
  );
}
